/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fond_Loud_Yak_BlowInputs */

const en_fond_loud_yak_blow = /** @type {(inputs: Fond_Loud_Yak_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete failed`)
};

const de_fond_loud_yak_blow = /** @type {(inputs: Fond_Loud_Yak_BlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Löschen`)
};

/**
* | output |
* | --- |
* | "Delete failed" |
*
* @param {Fond_Loud_Yak_BlowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fond_loud_yak_blow = /** @type {((inputs?: Fond_Loud_Yak_BlowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fond_Loud_Yak_BlowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fond_loud_yak_blow(inputs)
	return de_fond_loud_yak_blow(inputs)
});